import * as images from '../../assets/projectImages.export';

const PROJECTS_DATA = {
  projects: [
    {
      id: 1,
      title: 'Kwan\'s Clothing',
      link: 'https://kwans-clothing.herokuapp.com/',
      icon: images.ecommerceIcon,
      languages: ['JavaScript (React.JS)', 'CSS (Sass)'],
      tools: ['Redux', 'Firebase', 'Stripe', 'Heroku'],
      description: 'Created an ecommerce website with React.JS with Redux and CSS with Sass. Authentication provided by Firebase. Hosted on Heroku, while the payment system is implemented through Stripe.',
      github: 'https://github.com/KwanYoon/Kwans-Clothing',
      images: [
        {
          id: 1,
          title: "Front page",
          image: images.ecommerceImage1
        },
        {
          id: 2,
          title: "Login page",
          image: images.ecommerceImage2
        },
        {
          id: 3,
          title: "Payment page",
          image: images.ecommerceImage3
        },
        {
          id: 4,
          title: "Shop page",
          image: images.ecommerceImage4
        },
      ],
      tags: ['React.JS', 'JavaScript', 'CSS', 'All']
    },
    {
      id: 2,
      title: 'Boardgame Central',
      link: 'https://boardgame-central.netlify.app/',
      icon: images.boardgameCentralIcon,
      languages: ['JavaScript (React.JS)', 'CSS'],
      tools: ['Socket.IO', 'Heroku', 'Netlify'],
      description: 'Built a website with React.JS that hosts many board games such as Reversi, Connect4, and TicTacToe that can be played locally and online, with multiplayer built with Socket.IO. Hosted on Heroku and Netlify.',
      github: 'https://github.com/KwanYoon/Boardgame-Central',
      images: [
        {
          id: 1,
          title: "Home page",
          image: images.boardgameCentralImage1,
        },
        {
          id: 2,
          title: "Multiplayer",
          image: images.boardgameCentralImage2,
        },
        {
          id: 3,
          title: "TicTacToe",
          image: images.boardgameCentralImage3,
        },
        {
          id: 4,
          title: "Connect 4",
          image: images.boardgameCentralImage4,
        }
      ],
      tags: ['React.JS', 'JavaScript', 'CSS', 'All']
    },
    {
      id: 3,
      title: 'Bzzt',
      link: 'https://bzzt.netlify.app/',
      icon: images.bzztIcon,
      languages: ['JavaScript (React.JS, Node.JS, Express.JS)', 'CSS (Material-UI)'],
      tools: ['Redux', 'MongoDB', 'Heroku', 'Netlify'],
      description: 'Built a full-stack social media web application that allows users to create, read, update, and delete posts. Data stored in a MongoDB Database and hosted on Heroku and Netlify.',
      github: 'https://github.com/KwanYoon/Bzzt',
      images: [
        {
          id: 1,
          title: "Home page",
          image: images.bzztImage1,
        },
        {
          id: 2,
          title: "Form",
          image: images.bzztImage2,
        },
        {
          id: 3,
          title: "JavaScript code",
          image: images.bzztImage3,
        },
        {
          id: 4,
          title: "MongoDB",
          image: images.bzztImage4,
        }
      ],
      tags: ['React.JS', 'JavaScript', 'CSS', 'Database', 'All']
    },
    {
      id: 4,
      title: 'Pathfinding Visualizer',
      link: '',
      icon: images.pathfindingIcon,
      languages: ['Python'],
      tools: ['PyGame', 'Tkinter'],
      description: 'Pathfinding Visualizer created with Python and multiple pathfinding algorithms such as Dijkstra\'s and A*. Easy-to-follow GUI created with Tkinter.',
      github: 'https://github.com/KwanYoon/Python-Pathfinding-Visualizer',
      images: [
        {
          id: 1,
          title: "Setup",
          image: images.pathfindingImage1,
        },
        {
          id: 2,
          title: "A* Algorithm",
          image: images.pathfindingImage2,
        },
        {
          id: 3,
          title: "Dijkstra",
          image: images.pathfindingImage3,
        },
        {
          id: 4,
          title: "A* Algorithm 2",
          image: images.pathfindingImage4,
        }
      ],
      tags: ['Python', 'All']
    },
    {
      id: 5,
      title: 'Friends Manager',
      link: '',
      icon: images.friendsManagerIcon,
      languages: ['Python', 'SQL'],
      tools: ['MySQL'],
      description: 'Built an application where you can keep track of your friends\' birthdays, likes, dislikes, and other information with Python. The data stored on a MySQL local database can be created, read, updated, and deleted by the user.',
      github: 'https://github.com/KwanYoon/FriendsManager',
      images: [
        {
          id: 1,
          title: "Create",
          image: images.friendsManagerImage1,
        },
        {
          id: 2,
          title: "Update",
          image: images.friendsManagerImage2,
        },
        {
          id: 3,
          title: "Read",
          image: images.friendsManagerImage3,
        },
        {
          id: 4,
          title: "Delete",
          image: images.friendsManagerImage4,
        }
      ],
      tags: ['Python', 'SQL', 'Database', 'All']
    },
    {
      id: 6,
      title: 'Password Saver Android Application',
      link: '',
      icon: images.passwordSaverIcon,
      languages: ['Java', 'SQL', 'XML'],
      tools: ['SQLite'],
      description: 'Built a password saver disguised as a to-do list Android application with Java on Android Studio. Data stored in a SQLite Database for Android devices.',
      github: 'https://github.com/KwanYoon/Password-Saver-Android-Application',
      images: [
        {
          id: 1,
          title: "Main Page",
          image: images.passwordSaverImage1,
        },
        {
          id: 2,
          title: "Secret",
          image: images.passwordSaverImage2,
        },
        {
          id: 3,
          title: "Java",
          image: images.passwordSaverImage3,
        },
        {
          id: 4,
          title: "XML",
          image: images.passwordSaverImage4,
        }
      ],
      tags: ['Java', 'Database', 'SQL', 'XML', 'All']
    },
    {
      id: 7,
      title: 'Voice-Controlled News Web Application',
      link: 'https://kwany-alan-ai-news-app.netlify.app/',
      icon: images.voiceControlledNewsIcon,
      languages: ['JavaScript (React.JS)', 'CSS (Material-UI)'],
      tools: ['Alan AI', 'Netlify'],
      description: 'Built a news web application with React.JS and Alan AI, with a beautiful user interface created with Material-UI. Deployed with Netlify.',
      github: 'https://github.com/KwanYoon/Voice-Controlled-News-Web-Application',
      images: [
        {
          id: 1,
          title: "Front Page",
          image: images.voiceControlledNewsImage1,
        },
        {
          id: 2,
          title: "News Page",
          image: images.voiceControlledNewsImage2,
        },
        {
          id: 3,
          title: "React",
          image: images.voiceControlledNewsImage3,
        },
        {
          id: 4,
          title: "Alan Studio",
          image: images.voiceControlledNewsImage4,
        }
      ],
      tags: ['JavaScript', 'React.JS', 'CSS', 'All']
    },
    {
      id: 8,
      title: 'Space Duel',
      link: '',
      icon: images.spaceDuelIcon,
      languages: ['Python'],
      tools: ['PyGame'],
      description: 'Local 2-player PvP game built on Python and its PyGame library.',
      github: 'https://github.com/KwanYoon/Space-Duel',
      images: [
        {
          id: 1,
          title: "Game",
          image: images.spaceDuelImage1,
        },
        {
          id: 2,
          title: "End Screen",
          image: images.spaceDuelImage2,
        },
        {
          id: 3,
          title: "Python 1",
          image: images.spaceDuelImage3,
        },
        {
          id: 4,
          title: "Python 2",
          image: images.spaceDuelImage4,
        }
      ],
      tags: ['Python', 'All']
    },
    {
      id: 9,
      title: 'Game Deal Finder',
      link: '',
      icon: images.gameDealIcon,
      languages: ['JavaScript', 'HTML'],
      tools: [],
      description: 'Created a Chrome extension that tells users information about deals such as sales on other sites and historical low prices when on a Steam game page with JavaScript and HTML.',
      github: 'https://github.com/KwanYoon/Game-Deal-Finder',
      images: [
        {
          id: 1,
          title: "Steam Page",
          image: images.gameDealImage1,
        },
        {
          id: 2,
          title: "After Usage",
          image: images.gameDealImage2,
        },
        {
          id: 3,
          title: "JavaScript",
          image: images.gameDealImage3,
        },
        {
          id: 4,
          title: "JSON / HTML",
          image: images.gameDealImage4,
        }
      ],
      tags: ['JavaScript', 'All']
    },
    {
      id: 10,
      title: 'Discord Utility Bot',
      link: 'https://discord.com/api/oauth2/authorize?client_id=405892011162337283&permissions=8&scope=bot',
      icon: images.discordBotIcon,
      languages: ['Python'],
      tools: [],
      description: 'Using Discord.py, created a utility bot for my personal Discord server. Used PRAW - Reddit API Python Wrapper - to interact with Reddit within Discord.',
      github: 'https://github.com/KwanYoon/RemBot',
      images: [
        {
          id: 1,
          title: "Discord",
          image: images.discordBotImage1,
        },
        {
          id: 2,
          title: "Python",
          image: images.discordBotImage2,
        },
      ],
      tags: ['Python', 'All']
    },
    {
      id: 11,
      title: 'Blog Site',
      link: 'https://kwanyoon.netlify.app/',
      icon: images.blogSiteIcon,
      languages: ['JavaScript (React.JS)', 'CSS (TailwindCSS)'],
      tools: ['Sanity.IO', 'Netlify'],
      description: 'Built a personal blog site frontend designed with React.js and TailwindCSS and backend setup with Sanity.io.',
      github: 'https://github.com/KwanYoon/Personal-Blog',
      images: [
        {
          id: 1,
          title: "Home Page",
          image: images.blogSiteImage1,
        },
        {
          id: 2,
          title: "Blog Page",
          image: images.blogSiteImage2,
        },
        {
          id: 3,
          title: "React.JS",
          image: images.blogSiteImage3,
        },
        {
          id: 4,
          title: "Sanity Studio",
          image: images.blogSiteImage4,
        }
      ],
      tags: ['JavaScript', 'React.JS', 'CSS', 'All']
    },
  ]
}

export default PROJECTS_DATA;
